import { PropsWithChildren, ReactNode } from "react";
import { bulletContainer, bulletItemContainer, content } from "./styles.css";

export const BulletLIstItem = ({
  children,
  bullet,
  small,
}: PropsWithChildren<{ bullet: ReactNode; small?: boolean }>) => {
  const variant = small ? "small" : "default";

  return (
    <div className={bulletItemContainer[variant]}>
      <div className={bulletContainer[variant]}>{bullet}</div>
      <div className={content[variant]}>{children}</div>
    </div>
  );
};
